import ProductsMobile from './ProductsMobile';

export default ProductsMobile;
